<template>
  <v-page page="MyDashboards" :breadcrumb="breadcrumb">
    <v-container ma-0 px-4 pt-3 pb-0 style="overflow-x: scroll;">
      <!-- HEADER -->
      <v-layout justify-start row align-center mt-0 mb-0 style="min-height: 46px;">
        <v-flex align-center>
          <div
            class="text-xs-left align-center"
            style="font-size: 20px; font-weight: 600;"
          >My Dashboards</div>
        </v-flex>
        <v-flex align-center xs8></v-flex>
        <v-flex>
          <v-layout class="buttons" justify-end row align-center>
            <a class="mb-1 mr-0 ml-1" @click="addDashboard">+ Add Dashboards</a>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- END HEADER -->

      <!-- START ADD DASHBOARD -->
      <add-dashboard
        ref="addDashboard"
        :addDashboardList="addDashboardList"
        :dashboards="dashboards"
      ></add-dashboard>
      <!-- END ADD DASHBOARD -->

      <!-- TWO COLUMN SYSTEM -->
      <v-layout row style="min-width: 900px">
        <v-flex
          v-for="column in dashboards"
          :key="column.index"
          xs6
          :class="[{'pr-2':column.index==1},{'pl-2':column.index==2}]"
        >
          <draggable
            :emptyInsertThreshold="300"
            :list="column.items"
            tag="v-layout"
            class="fill-width row wrap"
            :group="{ name: 'column' }"
            ghost-class="ghost"
          >
            <v-flex v-for="item in column.items" :key="item.id" xs12 pa-3 class="dashboard mb-3" style="min-width: 450px">
              <bar-chart-container
                height="300px"
                :DBID="item.id"
                :isMounted="true"
                :clearable="true"
                @close="closeDashboard"
                :tile="true"
              ></bar-chart-container>
            </v-flex>
          </draggable>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import BarChartContainer from "../../components/Dashboards/BarChartContainer.vue";
import "@/assets/css/main.css";
import draggable from "vuedraggable";
import axios from "axios";
import addDashboard from "./AddDashboard.vue";
import Bus from "../../bus";

export default {
  name: "MyDashboards",
  components: { VPage, BarChartContainer, draggable, addDashboard },

  data: () => ({
    allDashboards: [],
    userDashboard: {},
    loaded: 0,
    dashboards: [
      // {
      //   index: 1,
      //   items: [
      //     // {
      //     //   id: "1"
      //     // },
      //     // {
      //     //   id: "10"
      //     // },
      //     // {
      //     //   id: "14"
      //     // }
      //   ]
      // },
      // {
      //   index: 2,
      //   items: [
      //     // {
      //     //   id: "2"
      //     // },
      //     // {
      //     //   id: "4"
      //     // },
      //     // {
      //     //   id: "11"
      //     // }
      //   ]
      // }
    ],

    breadcrumb: [
      {
        text: "Dashboards",
        disabled: false,
        href: "#/dashboards"
      },
      {
        text: "My Dashboards",
        disabled: true,
        href: "#/my-dashboards"
      }
    ]
  }),
  computed: {
    currentDashboards() {
      var currentDashboards = [];

      this.dashboards.forEach(column => {
        column.items.forEach(element => {
          currentDashboards.push(element.id);
        });
      });
      return currentDashboards;
    },
    addDashboardList() {
      var allDashboards = this.allDashboards;
      var addDashboardList = [];
      if (allDashboards.length > 0) {
        addDashboardList = allDashboards.filter(element => {
          if (!this.currentDashboards.includes(element.DBID.toString())) {
            return true;
          }
        });
        return addDashboardList;
      } else {
        return addDashboardList;
      }
    }
  },
  watch: {
    dashboards: {
      deep: true,
      async handler() {
        if (this.loaded > 1) {
          this.userDashboard.Dashboards = await JSON.stringify(this.dashboards);
          var UserDashboardDto = await this.userDashboard;
          axios
            .post("api/Dashboards/updateUserDashboards/", UserDashboardDto)
            .then(res => {
              Bus.$emit("alert", {
                color: "success",
                message: "Updated Dashboards Successfully!"
              });
            });
        } else {
          this.loaded += 1;
        }
      }
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      axios.get("api/Dashboards/getDashboardList").then(res => {
        this.allDashboards = res.data;
      });

      axios
        .get("api/Dashboards/getUserDashboards")
        .then(res => {
          this.dashboards = JSON.parse(res.data.Dashboards);
          this.loaded = 1;
        })
        .catch(err => {
          console.log(err);
          (this.dashboards = [
            {
              index: 1,
              items: []
            },
            {
              index: 2,
              items: []
            }
          ]),
            (this.loaded = 1);
        });
    },
    closeDashboard(val) {
      var closeDialog = confirm("Would you like to close Dashboard D" + val+"?");
      if (closeDialog) {
        this.dashboards.forEach(column => {
          column.items.forEach(element => {
            if (val == element.id) {
              var elementLocation = column.items.indexOf(element);
              column.items.splice(elementLocation, 1);
            }
          });
        });
      }
    },
    addDashboard() {
      this.$refs.addDashboard.open();
    }
    // async onMoveCallback(evt, originalEvent) {
    //   var confirmDialog = await confirm(
    //     "Are you sure you would like to move the dashboard here?"
    //   );
    //   if (confirmDialog) {
    //     console.log(evt.draggedContext)
    //     console.log(evt.relatedContext)
    //   } else {
    //     return false;
    //   }
    // }
  }
};
</script>
<style scoped>
.dashboard {
  border: 1px solid #e5e5e5;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>